export default "__VITE_ASSET__DZR4czuQ__"